class StringUtils {
    static capitalizarPrimeiraLetra(str) {
        return str.replace(/\b\w/g, char => char.toUpperCase());
    }

    static isEmptyOrNull(value) {
        if (value === null || value === undefined) return true;
        
        // Se for string, verifica se está vazia após trim
        if (typeof value === 'string') return value.trim() === '';
        
        // Se for número, verifica se é NaN
        if (typeof value === 'number') return isNaN(value);
        
        // Se for objeto, verifica se está vazio (sem propriedades)
        if (typeof value === 'object') {
            // Array vazio
            if (Array.isArray(value)) {
                return value.length === 0;
            }
            // Objeto vazio
            return Object.keys(value).length === 0;
        }
        
        // Para outros tipos, considera não vazio
        return false;
    }

    static formatarData(data) {
        if (this.isEmptyOrNull(data)) return null;
        
        const dataObj = new Date(data);
        
        const dia = String(dataObj.getDate()).padStart(2, '0');
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0'); 
        const ano = dataObj.getFullYear();
        
        return `${dia}/${mes}/${ano}`;
    }
    
    static formatarDateToDataHumano(data, formato = 'dd/MM/yyyy') {
        if (this.isEmptyOrNull(data)) return '';
        
        const dataObj = data instanceof Date ? data : new Date(data);
        
        if (isNaN(dataObj.getTime())) return '';
        
        const dia = String(dataObj.getDate()).padStart(2, '0');
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0'); 
        const ano = dataObj.getFullYear();
        const horas = String(dataObj.getHours()).padStart(2, '0');
        const minutos = String(dataObj.getMinutes()).padStart(2, '0');
        const segundos = String(dataObj.getSeconds()).padStart(2, '0');
        
        let resultado = formato;
        
        // Substitui os padrões no formato
        resultado = resultado.replace('dd', dia);
        resultado = resultado.replace('MM', mes);
        resultado = resultado.replace('yyyy', ano);
        resultado = resultado.replace('HH', horas);
        resultado = resultado.replace('mm', minutos);
        resultado = resultado.replace('ss', segundos);
        
        return resultado;
    }
}

export default StringUtils;